module.exports = __webpack_public_path__ + "static/media/picture.1521e750.svg";